// Web push (FCM) registration for browsers.
// Requires a Web Push (VAPID) public key from the Firebase console:
//   Project settings → Cloud Messaging → Web Push certificates → "Key pair".
// Provide it via REACT_APP_FCM_VAPID_KEY. Without it, web push silently no-ops
// (mobile push via the Flutter app is unaffected). The Firebase config below is
// public and matches the rhci-church project.
import { pushAPI } from '@/lib/api';

const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyCje3e1Ky4rzDn0oQGBcQb8EEHK78dDdUA',
  authDomain: 'rhci-church.firebaseapp.com',
  projectId: 'rhci-church',
  storageBucket: 'rhci-church.firebasestorage.app',
  messagingSenderId: '365540005256',
  appId: '1:365540005256:web:011bc2436b5aa40a20963d',
};

const VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;

let initialized = false;

/** Call after login. Registers this browser's FCM token against the user. */
export async function initWebPush() {
  if (initialized) return;
  if (typeof window === 'undefined') return;
  if (!('serviceWorker' in navigator) || !('Notification' in window)) return;
  if (!VAPID_KEY) {
    // Not configured — web push is optional; mobile push still works.
    return;
  }
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const swReg = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

    // Lazy-load the modular SDK so it stays out of the main bundle.
    const { initializeApp, getApps } = await import('firebase/app');
    const { getMessaging, getToken, onMessage } = await import('firebase/messaging');

    const app = getApps().length ? getApps()[0] : initializeApp(FIREBASE_CONFIG);
    const messaging = getMessaging(app);

    const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: swReg });
    if (token) {
      await pushAPI.registerDevice({ token, platform: 'web' });
      initialized = true;
    }

    // Foreground messages: surface a toast + browser notification.
    onMessage(messaging, (payload) => {
      const title = payload?.notification?.title || 'NaziriteOS';
      const body = payload?.notification?.body || '';
      try { new Notification(title, { body, icon: '/logo192.png' }); } catch (_) {}
    });
  } catch (err) {
    // Non-fatal — never block the app on push setup.
    if (process.env.NODE_ENV === 'development') console.warn('web push init failed', err);
  }
}
